import React from 'react';
import { Form } from 'react-bootstrap';
import TimeField from 'react-simple-timefield';

// subcomponente hora
function InputHora({
    value,
    onChange,
    className='',
    disabled=false,
    aceitarNull=true,
    aceitarMeiaNoite=false,
    size="md",
    isInvalid=false,
    ...rest
}){

    return <TimeField 
        style={{color: value === null ? '#dedede': 'black'}}
        disabled={disabled}
        value={value || ''}
        onChange={(valor) => {
            if(valor === '00:00' && !aceitarMeiaNoite){
                valor = null
            }else{
                valor += ':00';
            }

            if(valor === null && aceitarNull === false){
                valor = '00:00:00';
            }

            // alterarDados({...dados, hora: value})
            onChange(valor);
        }}
        onFocus={(e) => {
            e.target.select();
        }}
        input={<Form.Control size={size} isInvalid={isInvalid} placeholder="" className={[className].join(' ')} />}
        colon=":"
        {...rest}
    />
}

// exporta
export default InputHora;